<app-page-title title="Permissões e Acessos"></app-page-title>

<div class="page-header">
  <h2>Painel de Controle de Acesso</h2>
  <p>Selecione abaixo a categoria que deseja gerenciar. As permissões são aplicadas a membros através de funções, que são compostas por roles do sistema atreladas a entidades.</p>
</div>

<div class="options">
  <div class="option-card" *ngFor="let option of options" [routerLink]="[option.route]">
    <div class="icon-container" [ngClass]="option.colorClass">
      <mat-icon>{{ option.icon }}</mat-icon>
    </div>
    <div class="card-content">
      <h3>{{ option.label }}</h3>
      <p>{{ option.description }}</p>
    </div>
    <div class="arrow-indicator">
      <mat-icon>arrow_forward_ios</mat-icon>
    </div>
  </div>
</div>
